import { showAppMessage } from '@rainbow-modules/app';

const showErrorMessage = (message) => showAppMessage({
    message,
    variant: 'error',
});

export default showErrorMessage;
